import { callFunction } from "./functions-client";

// Typed calls to the `identity` edge function group. The client holds no
// supabase-js: auth runs server-side and returns a bearer token (ADR-0013).

export interface Account {
  id: string;
  email: string | null;
  status: string;
  identity_verified: boolean;
  created_at: string;
}

export interface Session {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  user_id: string;
  mfa_required?: boolean;
  factor_id?: string | null;
  email_mfa_required?: boolean;
}

export interface Me {
  account: Account | null;
  roles: string[];
}

export const registerAccount = (email: string, password: string, turnstileToken?: string | null) =>
  callFunction<Session & { ok: boolean }>("identity/register", {
    body: { email, password, turnstile_token: turnstileToken },
  });

export const loginAccount = (email: string, password: string, turnstileToken?: string | null) =>
  callFunction<Session>("identity/login", { body: { email, password, turnstile_token: turnstileToken } });

export const fetchMe = (token: string) =>
  callFunction<Me>("identity/me", { method: "GET", token });

export const logoutAccount = (token: string) =>
  callFunction<{ ok: boolean }>("identity/logout", { body: {}, token });
